import React from 'react';

const Footer = () => {
  return (
    <footer style={{ 
      padding: '2rem 0', 
      textAlign: 'center', 
      borderTop: '1px solid var(--card-border)',
      background: 'transparent',
      marginTop: 'auto'
    }}>
      <p style={{ 
        margin: 0, 
        color: 'var(--text-secondary)', 
        fontSize: '0.95rem',
        letterSpacing: '0.5px'
      }}>
          Copyright © 2026 Ankit Sahoo - All Rights Reserved.
      </p>
    </footer>
  );
};

export default React.memo(Footer);

